import { useCallback, useRef, useEffect } from "react";
import { t as trackDatadogActions, h as getIsDatadogInitialized } from "./public-get.api-DZnPQWa9.js";
var Environments = /* @__PURE__ */ ((Environments2) => {
  Environments2["dev"] = "dev";
  Environments2["tst"] = "tst";
  Environments2["acc"] = "acc";
  Environments2["prd"] = "prd";
  Environments2["cn_tst"] = "cn_tst";
  Environments2["cn_prd"] = "cn_prd";
  return Environments2;
})(Environments || {});
var PassportClients = /* @__PURE__ */ ((PassportClients2) => {
  PassportClients2["CustomerCM"] = "CustomerCM";
  PassportClients2["SuitsupplyCM"] = "SuitsupplyCM";
  PassportClients2["CustomerRTW"] = "CustomerRTW";
  PassportClients2["SuitsupplyRTW"] = "SuitsupplyRTW";
  PassportClients2["SuitsupplyRealt"] = "SuitsupplyRealt";
  return PassportClients2;
})(PassportClients || {});
var MeasComponentPlacement = /* @__PURE__ */ ((MeasComponentPlacement2) => {
  MeasComponentPlacement2["ProductDetailPage"] = "ProductDetailPage";
  MeasComponentPlacement2["ProductDetailPageWithRTWOnline"] = "ProductDetailPageWithRTWOnline";
  MeasComponentPlacement2["ProductListingPage"] = "ProductListingPage";
  MeasComponentPlacement2["ProductListingPageFilter"] = "ProductListingPageFilter";
  return MeasComponentPlacement2;
})(MeasComponentPlacement || {});
function useDataDogActionTrackingOnMount(eventConfig) {
  const MAX_RETRIES = 50;
  const isTracked = useRef(false);
  const {
    trackAction
  } = useDataDogActionTracking();
  const trackActionWhenInitialized = useCallback((retryCount = 0) => {
    if (retryCount >= MAX_RETRIES) {
      console.error("DataDog initialization failed after maximum retries.");
      return;
    }
    if (!getIsDatadogInitialized() && eventConfig) {
      setTimeout(() => trackActionWhenInitialized(retryCount + 1), 100);
      return;
    }
    if (eventConfig && !isTracked.current) {
      trackAction(eventConfig);
      isTracked.current = true;
    }
  }, [eventConfig, trackAction, isTracked]);
  useEffect(() => {
    if (eventConfig && !isTracked.current) {
      trackActionWhenInitialized();
    }
  }, [eventConfig, trackActionWhenInitialized]);
}
function useDataDogActionTracking() {
  const trackAction = useCallback((eventConfig) => {
    trackDatadogActions(eventConfig);
  }, []);
  return {
    trackAction
  };
}
const COMMON_QUERY_STALE_TIME = 5 * 60 * 1e3;
export {
  COMMON_QUERY_STALE_TIME as C,
  Environments as E,
  MeasComponentPlacement as M,
  PassportClients as P,
  useDataDogActionTrackingOnMount as a,
  useDataDogActionTracking as u
};
